export const playstore_deeplink =
  "https://play.google.com/store/apps/details?id=com.esmagico.pawfect&hl=en";
export const appstore_deeplink =
  "https://apps.apple.com/in/app/pawfect/id6474994092";
